export const DestinationPushStatus = {
  PENDING: 'PENDING',
  IN_PROGRESS: 'IN_PROGRESS',
  FAILED: 'FAILED',
  REVERTED: 'REVERTED',
  REVERT_FAILED: 'REVERT_FAILED',
  COMPLETE: 'COMPLETE',
  INTERNAL_FAILURE: 'INTERNAL_FAILURE',
  REVERTING: 'REVERTING',
};

export const PUSHES_REFRESH_STATUSES = [
  DestinationPushStatus.IN_PROGRESS,
  DestinationPushStatus.PENDING,
  DestinationPushStatus.REVERTING,
];
